export default "__VITE_ASSET__DEx3njWZ__"